import { labById } from "../data/v1";
import type { LabId } from "../types";

const logoByLab: Record<LabId, string> = {
  anthropic: "/logos/anthropic.svg",
  deepseek: "/logos/deepseek.ico",
  google: "/logos/google-deepmind.svg",
  kimi: "/logos/kimi.ico",
  minimax: "/logos/minimax.ico",
  openai: "/logos/openai.svg",
  qwen: "/logos/qwen.webp",
  spacexai: "/logos/spacexai.png",
  zai: "/logos/zai.svg",
};

interface LabLogoProps {
  className?: string;
  labId: LabId;
  tone?: "light" | "dark";
}

export function LabLogo({ className = "", labId, tone = "light" }: LabLogoProps) {
  const source =
    labId === "anthropic" && tone === "dark"
      ? "/logos/anthropic-ivory.svg"
      : logoByLab[labId];
  const labName = labById.get(labId)?.name ?? labId;

  return (
    <span
      aria-label={`${labName} logo`}
      className={`lab-logo ${className}`.trim()}
      data-lab={labId}
      role="img"
    >
      <img alt="" draggable={false} src={source} />
    </span>
  );
}
